import {
  LOADING,
  ACCOUNTINFO,
  ACCOUNTINFO_ERROR,
  SUBSCRIPTIONACCOUNTINFO,
  SUBSCRIPTIONACCOUNTINFO_ERROR,
  EMPTY_ERROR_COMMON_OBJ,
  UPDATEACCOUNTINFO,
  MAILALERTINFO,
  MAILALERTINFO_ERROR,
  USAGEACCOUNTINFO,
  USAGEACCOUNTINFO_ERROR,
  UPDATEPASSWORDINFO,
  UPDATEPASSWORDINFO_ERROR,
  USAGELEADACCOUNTINFO,
  USAGELEADACCOUNTINFO_ERROR,
  RESETPASSWORDINFO,
  RESETPASSWORDINFO_ERROR,
  SUBSCRIPTIONS,
  NOTIFICATIONS,
} from "../actionType/commonType";
import {
  accountInfoApiUrl,
  subscriptionaccountInfoApiUrl,
  mailerApiUrl,
  ussageApiUrl,
  changePasswordApiUrl,
  ussageLeadCountApiUrl,
  forgotPasswordApiUrl,
  resetPasswordApiUrl,
  logoutUrl,
  subscriptionPackages,
  notifications,
  refreshTokenUrl,
} from "../constant/Constant";

import {
  getAuthMethod,
  patchAuthMethod,
  postAuthMethod,
  postMethod,
} from "../services/HttpServices";
import { ErrKey, errEnum } from "../config";
import { getUserInfo } from "../utils/utils";
import { getToken, setToken } from "../utils/auth";
const originURL = window.location.origin;
const baseUrl = process.env.REACT_APP_BACKEND_URL;
export const dispatchStatus = (payload) => {
  return {
    type: LOADING,
    payload: payload,
  };
};

export const getAccountInfo = (token) => (dispatch) => {
  dispatch(dispatchStatus(true));
  return getAuthMethod(accountInfoApiUrl, token)
    .then(async (res) => {
      dispatch({
        type: ACCOUNTINFO,
        payload: res.data,
      });
      const subRes = await dispatch(getSubscriptionInfo(token, res.data));
      localStorage.setItem("userInfo", JSON.stringify(res.data));
      dispatch(dispatchStatus(false));
      return { ...res.data, validTo: subRes?.validTo };
    })
    .catch((err) => {
      dispatch(dispatchStatus(false));
      if (!err?.response?.data) return;
      dispatch({
        type: ACCOUNTINFO_ERROR,
        payload:
          { [errEnum.ACCOUNTINFO_ERROR]: err.response.data[ErrKey] } ||
          "Error Occured",
      });
    });
};

export const getSubscriptionInfo = (token, data) => (dispatch) => {
  if (data?.subscriberId) {
    //subscriberId TODO previouse data - data?.account?.subscriberId
    return getAuthMethod(
      subscriptionaccountInfoApiUrl + data?.subscriberId,
      token,
    )
      .then((res) => {
        dispatch({
          type: SUBSCRIPTIONACCOUNTINFO,
          payload: res.data,
        });
        localStorage.setItem("subscriptionuserInfo", JSON.stringify(res.data));
        return res?.data;
      })

      .catch((err) => {
        if (!err?.response?.data) return;
        dispatch({
          type: SUBSCRIPTIONACCOUNTINFO_ERROR,
          payload:
            {
              [errEnum.SUBSCRIPTIONACCOUNTINFO_ERROR]:
                err.response.data[ErrKey],
            } || "Error Occured",
        });
      });
  }
};

export const getUsageDetails = (token, id) => (dispatch) => {
  //ussage-details
  return getAuthMethod(ussageApiUrl + "?accountId.equals=" + id, token)
    .then((res) => {
      dispatch({
        type: USAGEACCOUNTINFO,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: USAGEACCOUNTINFO_ERROR,
        payload:
          {
            [errEnum.USAGEACCOUNTINFO_ERROR]: err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getLeadCount = (token, id) => (dispatch) => {
  //ussage-details
  return getAuthMethod(ussageLeadCountApiUrl, token)
    .then((res) => {
      dispatch({
        type: USAGELEADACCOUNTINFO,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: USAGELEADACCOUNTINFO_ERROR,
        payload:
          {
            [errEnum.USAGELEADACCOUNTINFO_ERROR]: err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};
export const emptyCommonErrorObj = () => ({
  type: EMPTY_ERROR_COMMON_OBJ,
  payload: {},
});

export const resetaccountInfo = () => ({
  type: UPDATEACCOUNTINFO,
  payload: {},
});

export const updateAccountInfo = (token, payload) => (dispatch) => {
  const { id: userId } = getUserInfo();
  return patchAuthMethod(accountInfoApiUrl, userId, { id: userId, ...payload })
    .then((res) => {
      dispatch({
        type: UPDATEACCOUNTINFO,
        payload: { msg: true },
      });
      dispatch(getAccountInfo(token));
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const changePassword = (token, payload) => (dispatch) => {
  return postAuthMethod(changePasswordApiUrl, payload)
    .then((res) => {
      dispatch({
        type: UPDATEPASSWORDINFO,
        payload: { msg: true },
      }); //res.data
      dispatch(getAccountInfo(token));
      return res;
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: UPDATEPASSWORDINFO_ERROR,
        payload:
          { [errEnum.UPDATEPASSWORDINFO_ERROR]: err.response.data[ErrKey] } ||
          "Error Occured",
      });
      return err;
    });
};

export const resetPasswordInfo = () => (dispatch) => {
  dispatch({
    type: UPDATEPASSWORDINFO,
    payload: {},
  });
};
export const resetAccountInfo = () => (dispatch) => {
  dispatch({
    type: ACCOUNTINFO,
    payload: {},
  });
  dispatch({
    type: SUBSCRIPTIONACCOUNTINFO,
    payload: {},
  });
};
export const resetMailAlert = () => (dispatch) => {
  dispatch({
    type: MAILALERTINFO,
    payload: {},
  });
};

export const sendMailAlert = (payload) => (dispatch) => {
  return postMethod(mailerApiUrl, payload)
    .then((res) => {
      dispatch({
        type: MAILALERTINFO,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: MAILALERTINFO_ERROR,
        payload:
          { [errEnum.MAILALERTINFO_ERROR]: err.response.data[ErrKey] } ||
          "Error Occured",
      });
    });
};

export const forgotPassword = (email) => (dispatch) => {
  return postAuthMethod(forgotPasswordApiUrl, email)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const resetPassword = (payload) => (dispatch) => {
  return postAuthMethod(resetPasswordApiUrl, payload)
    .then((res) => {
      dispatch({
        type: RESETPASSWORDINFO,
        payload: { msg: true },
      });
      // dispatch(getAccountInfo(token));
    })
    .catch((err) => {
      dispatch({
        type: RESETPASSWORDINFO_ERROR,
        payload: { msg: false },
      });
      // if (!err?.response?.data) return;
      // dispatch({
      //   type: RESETPASSWORDINFO_ERROR,
      //   payload:
      //     { [errEnum.RESETPASSWORDINFO_ERROR]: err.response.data[ErrKey] } ||
      //     "Error Occured",
      // });
    });
};

export const logout = (token) => (dispatch) => {
  return postAuthMethod(logoutUrl, token, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((res) => {
      sessionStorage.removeItem("trialModalShown");
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getSubscriptions = () => (dispatch) => {
  return getAuthMethod(subscriptionPackages)
    .then((res) => {
      dispatch({
        type: SUBSCRIPTIONS,
        payload: res.data?.packageDTOs,
      });
    })
    .catch((err) => {
      return err;
    });
};

export const getNotifications = () => (dispatch) => {
  return getAuthMethod(`${notifications}?isRead.equals=false`)
    .then((res) => {
      dispatch({
        type: NOTIFICATIONS,
        payload: res.data,
      });
    })
    .catch((err) => {
      return err;
    });
};

export const readNotification = (id) => (dispatch) => {
  return patchAuthMethod(
    notifications,
    id,
    { isRead: true, id },
    {
      baseURL: baseUrl,
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/merge-patch+json",
        "Access-Control-Allow-Origin": "*",
        origin: originURL,
      },
    },
  )
    .then((res) => {
      dispatch(getNotifications());
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const refreshToken = () => (dispatch) => {
  const storedData = JSON.parse(localStorage.getItem("auth"));
  return postAuthMethod(refreshTokenUrl, {
    refreshToken: storedData?.refreshToken,
  })
    .then((res) => {
      setToken(
        res.data.id_token,
        storedData?.rememberMe,
        res?.data?.refresh_token,
      );
      return res;
    })
    .catch((err) => {
      return err;
    });
};
